import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Commercial, User } from '@shared/models';
import { Subscription } from 'rxjs/Subscription';



@Component({
  selector: 'app-program-select',
  templateUrl: './program-select.component.html',
  styleUrls: ['./program-select.component.css']
})

export class ProgramSelectComponent implements OnInit {

  @Input('programGroup')
  public programControl: FormGroup;


  @Output('update')
  switched: EventEmitter<any> = new EventEmitter();
  
  public programs: any;
  public programInfo: any;
  public programOptions: any;
  public commercial: any;
  private user: User;
  subscription: Subscription;
  commercialSubscription: Subscription;
  public optradio = null;

  constructor(private _userService: UserService, private _fb: FormBuilder, private _authGuard: AuthGuardService, private _commercial: CommercialService) { 
    this.programControl = this._fb.group({
      optradio: new FormControl()
  })
  }

  ngOnInit() {
    this.commercialSubscription = this._commercial.getCommercialValue().subscribe(commercial =>{
      this.commercial = commercial;
    });

    this.subscription = this._userService.getUser().subscribe(user => {
        this.user = user;
    if(this.user.accountSummaryArray){
      if(this.user.accountSummaryArray.length > 0){
        this.getProgramTypes();
      }
    }
    });


    this.getProgramTypes();
  }

  private getProgramTypes() {
    this._authGuard.authenticatedPost('portfolios/NexpressProgramTypes', { "IsCommercial": this.commercial.isCommercialDomain}).subscribe(
        result => {
            let programResult: any;
            programResult = result;
            this.programs = programResult.NexpressProgramTypes;
            this.programInfo = this.programs;
            this.programOptions = [];
            this.programs.forEach(element => {
              element.Name = element.Name.split('-')[0].trim()
              if (!(this.programOptions.filter(e => e.Name === element.Name).length > 0)){
                this.programOptions.push({Id: element.Id, Name: element.Name, Summary: element.Summary})
              }
            });
            console.log(this.programs);
            console.log(this.programOptions);
            this.setDefaults();
        },
        error => console.log('get program types Error:', error)
    );
}

  private setDefaults() {
    if(this.user.accountSummaryArray){
      if (this.user.accountSummaryArray.length > 0) {
      }
  }
  }

  handlePanelClick(event){
    console.log(event);
    this.programInfo.forEach(element => {
      console.log(element)
      if(element.Id == event){
        console.log("found")
        let fields:any = document.querySelectorAll('[value="' +event+ '"]');
        console.log(fields);
        fields.forEach(function(node) {
          if(node.type === "radio"){
            node.checked = true;
          }
        })
        this.switched.emit({program: element, programInfo: this.programInfo});
      }
    });
  }

  handleChange(event){
    console.log(event);
    this.programInfo.forEach(element => {
      console.log(element)
      if(element.Id == event.target.value){
        console.log("found")
        this.switched.emit({program: element, programInfo: this.programInfo});
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/program-select/program-select.component.ts